module.exports = __webpack_public_path__ + "img/oc_bmpm.gm.edd6080.png";